import { Outlet, createFileRoute } from "@tanstack/react-router";

import { caseDetailQueryOptions } from "@/features/cases/queries";
import { caseTitleCrumb } from "@/lib/crumb-resolvers";

// 注: ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
export const Route = createFileRoute("/_authenticated/member/$id")({
  staticData: { crumb: caseTitleCrumb("/member/$id") },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(caseDetailQueryOptions(params.id)),
  component: () => <Outlet />,
});
